import type { Deal, ScenarioSettings, Targets } from './flip';

export type Status = 'watching' | 'bought' | 'repairing' | 'listed' | 'sold' | 'passed';

export const STATUSES: readonly Status[] = ['watching', 'bought', 'repairing', 'listed', 'sold', 'passed'];

export const STATUS_LABEL: Record<Status, string> = {
  watching: 'Watching',
  bought: 'Bought',
  repairing: 'Repairing',
  listed: 'Listed for sale',
  sold: 'Sold',
  passed: 'Passed on',
};

/** One car: the plan you made, and the numbers as they really turn out. */
export interface Car {
  id: string;
  title: string;
  reg: string;
  source: string;
  status: Status;
  /** The deal as first planned. Never changes, so plan and reality can be compared. */
  planned: Deal;
  /** The deal as it stands now: update it with real prices as they happen. */
  deal: Deal;
  /** Dates as YYYY-MM-DD, or empty. */
  boughtOn: string;
  soldOn: string;
  notes: string;
  /** Checklist items ticked, by item id. */
  checks: Record<string, boolean>;
  createdAt: string;
  updatedAt: string;
}

export interface Settings {
  targets: Targets;
  scenarios: ScenarioSettings;
  /** Cash set aside for buying cars. */
  startingCash: number;
  /** Values new deals start with. */
  defaults: Deal;
}

export interface AppData {
  version: 1;
  settings: Settings;
  cars: Car[];
}
